import { useNavigate } from 'react-router-dom';
import { useCharterAdminProviders } from '../hooks/useCharter';
import { GatewayStateBadge } from '../components/CharterStatusBadge';
import {
  CharterHeader,
  EmptyState,
  ErrorState,
  LoadingState,
  TableCard,
  TD,
  TD_MUTED,
  TH,
} from '../components/CharterPage';

/** TCS-admin: cross-provider directory of Charter providers. */
export function CharterProvidersPage() {
  const navigate = useNavigate();
  const { data: providers = [], isLoading, error } = useCharterAdminProviders();

  return (
    <div className="py-6 max-w-6xl mx-auto px-2">
      <CharterHeader
        title="Charter · Providers"
        subtitle="All Charter providers across the platform. Open one for profile, gateway state, policy and add-ons."
      />

      {isLoading ? (
        <LoadingState label="Loading providers…" />
      ) : error ? (
        <ErrorState label="Failed to load providers." />
      ) : providers.length === 0 ? (
        <EmptyState label="No Charter providers yet." />
      ) : (
        <TableCard>
          <table className="w-full">
            <thead>
              <tr className="border-b border-border bg-muted text-left">
                <th className={TH}>Provider</th>
                <th className={TH}>Timezone</th>
                <th className={TH}>Gateway</th>
                <th className={TH}></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {providers.map((p) => (
                <tr key={p.merchantId} className="hover:bg-muted transition-colors">
                  <td className={TD}>
                    <span className="font-medium">{p.branding?.displayName ?? p.merchantId}</span>
                    <span className="block text-xs text-muted-foreground font-mono">{p.merchantId}</span>
                  </td>
                  <td className={TD_MUTED}>{p.timezone ?? '—'}</td>
                  <td className="px-6 py-4">
                    <GatewayStateBadge state={p.gatewayState} />
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => navigate(`/charter/providers/${p.merchantId}`)}
                      className="text-xs text-blue-600 hover:underline"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableCard>
      )}
    </div>
  );
}
